// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"1d996d927be1d19b4eae","966":"cfafeead7fa4cdb619a5"}[chunkId] + ".js";
};